export const hashString = async (str: string): Promise<string> => {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export const uint8ArrayToHex = (byteArray: Uint8Array): string =>
  Array.from(byteArray)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')

export const int8ArrayToHex = (byteArray: Int8Array): string => uint8ArrayToHex(new Uint8Array(byteArray.buffer))

export const arrayBufferToHex = (buffer: ArrayBufferLike): string => uint8ArrayToHex(new Uint8Array(buffer))

export const hexToUint8Array = (hex: string): Uint8Array => {
  if (hex.length % 2 !== 0) {
    throw new Error('Hex string must have an even length')
  }
  const byteArray = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    byteArray[i / 2] = parseInt(hex.slice(i, i + 2), 16)
  }
  return byteArray
}
